import type { BaseController } from '@infra/controllers/base.controller';
import type {
  ConnectedTransferCallUsecase,
  ConnectedTransferCallWithCrmOpsRequest,
} from './connect-merge-transfer-call.usecase';

export type ConnectedTransferCallControllerInput =
  ConnectedTransferCallWithCrmOpsRequest | void;

export type ConnectedTransferCallControllerOutput = void;

export class ConnectedTransferCallController
  implements
    BaseController<
      ConnectedTransferCallControllerInput,
      ConnectedTransferCallControllerOutput
    >
{
  constructor(private usecase: ConnectedTransferCallUsecase) {}

  async handle(
    input: ConnectedTransferCallControllerInput,
  ): Promise<ConnectedTransferCallControllerOutput> {
    await this.usecase.run(input);
  }
}
